module.exports = __webpack_public_path__ + "mapovate-logo-white.d7a01ed47a91a889179ce004ac0085db.png";